import { Button, Grid, Hidden } from '@material-ui/core';
import { /*AddIcon,  ColumnsToolbarButton, DensitySelector, FilterToolbarButton,*/ GridAddIcon, GridColumnsToolbarButton, GridDensitySelector, GridFilterToolbarButton, GridToolbarContainer } from '@material-ui/data-grid';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import {  useContext } from 'react';
import { AppContext } from '../../../context/context';
import { useLocation } from 'react-router-dom';


const TableToolsBar = (props:any) => {
	const { api: {
		current: {
			componentsProps: {
				toolbar: {
					overide,
					editContent,
					createContent,
					deletableContent,
					setCheckable,
				}
			}
		}
	} } = props;
	//console.log(editTable)
	const { setSharedData, sharedData: { isLogged, isModalActive}  } = useContext(AppContext);
	const location = useLocation().pathname.split("/")[1].toLowerCase()
	const handleEdit = (): void => {
		setCheckable((prevState:boolean) => !prevState);
	}
	const handleDelete = (): void => {
		props.api.current.setState((prevState: any) => ({ ...prevState, selection: {}}))
		setCheckable((prevState: boolean) => !prevState);

	}
	const handleAdd = (): void => {
		let tempTarget:string;
		if (location === "campaigns") {
			tempTarget = "campaigns"
		} else {
			tempTarget = "missions"
		}
		setSharedData((prevState: any) => ({ ...prevState, isModalActive: !isModalActive, modalTarget: tempTarget, /*modalPayload:[]*/}))
	}

	return (
		<GridToolbarContainer>
			<Grid container justify="flex-start" >
				{!overide && <GridColumnsToolbarButton />}
				<Hidden only={["xs"]}>
					{!overide && <GridFilterToolbarButton /> }
				</Hidden>
				{!overide && <GridDensitySelector />}
			</Grid>{
				isLogged && 
			<Grid container justify="flex-end">
					{createContent &&
					<Button onClick={handleAdd}>
						<GridAddIcon />
					</Button>
					} {
					deletableContent && 
					<Button onClick={handleDelete}>
						<DeleteIcon />
					</Button>
					}
					{editContent &&
					<Button onClick={handleEdit}>
						<EditIcon />
					</Button>}
			</Grid>
			}
		</GridToolbarContainer>
	);
}

export default TableToolsBar;